import React from 'react';
import styled from 'styled-components';

import { Button } from '~ui-kit';
import { lighterBlue } from '~theme';

const NavButton = ({ showBadge, onClick, icon, children, mobile }) => {
  if (mobile) {
    return (
      <MobileWrapper onClick={onClick}>
        {showBadge && <NotificationBadge mobile />}
        <ButtonIcon src={icon} role="presentation" />
      </MobileWrapper>
    );
  }

  return (
    <Wrapper onClick={onClick}>
      {showBadge && <NotificationBadge />}
      <ButtonIcon src={icon} role="presentation" />
      <ButtonText>{children}</ButtonText>
    </Wrapper>
  );
};

const Wrapper = styled(Button)`
  position: relative;
  height: 42px;
  margin-left: 20px;
  padding: 12px 20px;
  background-color: ${lighterBlue};
`;

const MobileWrapper = styled.div`
  position: relative;
  height: 42px;
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const ButtonIcon = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 10px;
`;

const ButtonText = styled.span`
  color: white;
`;

const NotificationBadge = styled.div`
  position: absolute;
  left: ${props => (props.mobile ? '-3px' : '16px')};
  top: 8px;
  width: 12px;
  height: 12px;
  background-color: #ff8492;
  border-radius: 100%;
`;

export default NavButton;
